var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6 58.2997L56.7233 45.4663C57.7133 44.733 57.7133 43.2663 56.7233 42.533L39.6 29.6997C38.39 28.783 36.6666 29.663 36.6666 31.1663V56.833C36.6666 58.3363 38.39 59.2163 39.6 58.2997ZM44 7.33301C23.76 7.33301 7.33331 23.7597 7.33331 43.9997C7.33331 64.2397 23.76 80.6663 44 80.6663C64.24 80.6663 80.6666 64.2397 80.6666 43.9997C80.6666 23.7597 64.24 7.33301 44 7.33301ZM44 73.333C27.83 73.333 14.6666 60.1697 14.6666 43.9997C14.6666 27.8297 27.83 14.6663 44 14.6663C60.17 14.6663 73.3333 27.8297 73.3333 43.9997C73.3333 60.1697 60.17 73.333 44 73.333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.5e2691cb2635db658f456f4834903389.svg";
export { ForwardRef as ReactComponent };